import { app } from '../shared';

export const patchUserAccount = async (token, body) => {
  return app.service('user-credentials').patch(token, body);
};
